module.exports = __webpack_public_path__ + "img/after920.07282536.jpg";